import React from "react";
import {Navigate, useParams} from "react-router-dom";

export function CompanyDetailRedirect() {
    const {id} = useParams();
    if (!id) {
        return <Navigate to="/settings/company" replace />;
    }
    return <Navigate to={`/settings/company?selectedId=${id}`} replace />;
}

export function CompanyCreateRedirect() {
    return <Navigate to="/settings/company" replace />;
}
